import React, { useState , useEffect} from "react";
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { SpeedDial } from 'primereact/speeddial';
import { RadioButton } from "primereact/radiobutton";
import { InputText } from 'primereact/inputtext';
import InputTextCNPJ from "../../../Componentes/InputTextCNPJ"; // Verifique se o caminho está correto
import InputTextCPF from "../../../Componentes/InputTextCPF";
import InputCEP from "../../../Componentes/InputTextCEP";
import InputTextTelefone from "../../../Componentes/InputTextTelefone";
import InputTextEmail from "../../../Componentes/InputTextEmail";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import fontConfig, {Icones} from "../../../Componentes/FontConfig";




export default function FormEdicaoCliente(props) {
    const [visible, setVisible] = useState(false)
    const [errors, setErrors] = useState({});
    const [tipoCadastro, setTipoCadastro] = useState('juridica'); // Inicializa como 'juridica'
    const toast = React.useRef(null); // Ref para o Toast
    const [cliente, setCliente] = useState({
        ...props.cliente
    })




     useEffect(()=>{
            if(cliente.cpf_cnpj){
                
                setTipoCadastro(cliente.cpf_cnpj.length== 14 ? 'fisica' : 'juridica')
    
            }
    
        }, [cliente?.cpf_cnpj])

    const handleChange = (e) => {
        const { name, value } = e.target;
        setCliente(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const setCadastroCliente = () =>{
        setCliente({
            ...cliente, 
            statusCadastro : 'edicao', 
            idcliente :  -1,
            razaosocial :  "",
            nomefantasia :  "",
            cpf_cnpj :  "",
            rg_insc :  "",
            logradouro :  "",
            numero :  "",
            complemento :  "",
            bairro :  "",
            cep :  "",
            cidade :  "",
            estado :  "",
            telefonecomercial :  "",
            telefonecelular :  "",
            email :  "",
            ativo :  "t",
        })
    }
    useEffect(()=>{
        setCliente(()=>props.cliente)
    },[props.cliente])

    

    const updateCliente = () =>{
      
        props.Conexao.post('clientesController/updateCliente', {
            ...cliente,
            idcliente : cliente.idcliente,
            cnpj: cliente.cpf_cnpj,
            inscEstadual: cliente.rg_insc,
            razaoSocial: cliente.razaosocial,
            nomeFantasia: cliente.nomefantasia,
            endereco:cliente.logradouro ,    
            telefoneCelular: cliente.telefonecelular,
            telefoneComercial: cliente.telefonecelular

        }).then(response =>{
            if(response.status == 200 && response.data.status === 'OK'){
                    props.showMessage('success', 'CADASTRO CLIENTES', 'Registro atualizado com sucesso!')
                    setVisible(false)
                    props.updateClientes(cliente)
            }
        }).catch(error => {
            props.showMessage('danger', 'CADASTRO CLIENTES', 'Não foi possível atualizar')
            setVisible(false)
        })
    }


    const showMessageToast = (severity, msg) => {
        switch(severity){
            case "error":
                toast.current.show({
                    severity: "error",
                    summary: "Erro",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

            case "success":
                toast.current.show({
                    severity: "success",
                    summary: "Sucess",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

            case "warn":
                toast.current.show({
                    severity: "warn",
                    summary: "Warning",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

        }
        
      };

      const validateFields = () => {
     
        let newErrors = {};
    
        if (!cliente.cpf_cnpj) newErrors.cpf_cnpj = "CPF/CNPJ é obrigatório";
        if (!cliente.razaosocial) newErrors.razaosocial = "Razão Social/Nome Completo é obrigatório";
        if (!cliente.nomefantasia) newErrors.nomefantasia = "Nome Fantasia/Apelido é obrigatório";
        if (!cliente.email) newErrors.email = "E-mail é obrigatório";
        if (!cliente.cidade) newErrors.cidade = "A Cidade é obrigatório";
        if (!cliente.estado) newErrors.estado = "UF é obrigatório";
        if (!cliente.cep) newErrors.cep = "CEP é obrigatório";
    
        setErrors(newErrors);
    
        return Object.keys(newErrors).length === 0; // Retorna true se não houver erros
    };


      return (
            <div >            
              
               
               <Button disabled={props.disabled} severity="secondary" className="w-full" icon={props.Icones.Editar} onClick={() => {
                    if(props.dataEmpresa.bloqueiofinanceiro === 't') {
                            
                        showMessageToast("error", 'Este recurso esta Bloqueado! Entre em contato com a Databit');
                        return;
                    }  
                      setVisible(true)
                }} />
                <Dialog
                    header={"Alteração Cliente [" + cliente?.idcliente+"]"}
                    visible={visible}
                    maximizable
                    blockScroll={false} 
                    style={{ width: '60vw', }} // Largura padrão
                    breakpoints={{ '960px': '75vw', '720px': '90vw' }} // Ajuste para telas menores
                    onHide={() => setVisible(false)}
                >
                    {/* Opção de Pessoa Jurídica ou Física */}
                    <div className="flex flex-wrap gap-1" style={{padding : '10px', paddingBottom : '0px', paddingBottom : '0px'}}>
                        <div className="flex align-items-center col-12 md:col-3">
                            <RadioButton
                                inputId="juridica"
                                name="tipoCadastro"
                                value="juridica"
                                onChange={(e) => setTipoCadastro(e.value)}
                                checked={tipoCadastro === 'juridica'}
                            />
                            <label htmlFor="juridica" className="ml-2">Pessoa Jurídica</label>
                        </div>
    
                        <div className="flex align-items-center col-12 md:col-3">
                            <RadioButton
                                inputId="fisica"
                                name="tipoCadastro"
                                value="fisica"
                                onChange={(e) => setTipoCadastro(e.value)}
                                checked={tipoCadastro === 'fisica'}
                            />
                            <label htmlFor="fisica" className="ml-2">Pessoa Física</label>
                        </div>
                    </div>
                    <div className="grid mt-2"  style={{padding : '20px', paddingTop : '0px'}}>
                         <div className="col-12 md:col-3">
                                <label htmlFor="documento" style={{fontWeight : 'bold'}}>{tipoCadastro === 'juridica' ? 'CNPJ*' : "CPF*"}</label>
                                {
                                    tipoCadastro === 'juridica' ?
                                    <>
                                        <InputTextCNPJ
                                            value = {cliente.cpf_cnpj}
                                            onChange={handleChange}
                                            name="cnpj"
                                            className="w-full mt-2"
        
                                        />
                                        <small className="p-error">{errors.cnpj}</small>
                                        </>
                                        :
                                        <>
                                        <InputTextCPF
                                            onChange={handleChange}
                                            value = {cliente.cpf_cnpj}
                                            name="cnpj"
                                            className="w-full mt-2"
                                        />
                                        <small className="p-error">{errors.cnpj}</small>
                                        </>
                                }
                            </div>
                        
                         <div className="col-12 md:col-2">
                                <label htmlFor="inscEstadual">{tipoCadastro === 'juridica' ? 'IE' : "RG"}</label>
                                <InputText           
                                    value = {cliente.rg_insc}
                                    onChange={handleChange}
                                    name="inscEstadual"
                                    className="w-full mt-2"
                                />
                        </div>
                        <div className="col-12 md:col-7">
                            <label htmlFor="razaoSocial" style={{fontWeight : 'bold'}}>{tipoCadastro === 'juridica' ? 'Razão Social*' : "Nome Completo*"}</label>
                            <>
                            <InputText
                                value={cliente.razaosocial}
                                onChange={handleChange}
                                name="razaosocial"
                                className="w-full mt-2"
                            />
                                <small className="p-error">{errors.razaosocial}</small>
                                </>
                        </div>
                        <div className="col-12 md:col-3">
                            <label htmlFor="razaoSocial">{tipoCadastro === 'juridica' ? 'Nome Fantasia*' : "Apelido*"}</label>
                            <>
                            <InputText
                                value={cliente.nomefantasia}
                                onChange={handleChange}
                                name="nomefantasia"
                                className="w-full mt-2"
                            />
                                <small className="p-error">{errors.nomefantasia}</small>
                                </>
                        </div>

                        <div className="col-12 md:col-2">
                            <label htmlFor="razaoSocial" style={{fontWeight : 'bold'}}>CEP*</label>
                            <>
                            <InputCEP
                                value={cliente.cep}
                                onChange={handleChange}
                                setDataCep = {(data)=>{
                                    //  console.log(data)
                                    if(data){
                                        setCliente((prevState)=>({
                                            ...prevState, 
                                            logradouro : data.logradouro, 
                                            complemento : data.complemento, 
                                            bairro : data.bairro,
                                            cidade : data.localidade, 
                                            estado : data.uf
                                        }))
                                    }else{
                                        setCliente((prevState)=>({
                                            ...prevState, 
                                            logradouro : '', 
                                            complemento : '', 
                                            bairro : '',
                                            cidade : '', 
                                            estado : ''
                                        }))
                                    }
                                      
                                  }}
                                name="cep"
                                className="w-full mt-2"
                            />
                                <small className="p-error">{errors.cep}</small>
                                </>
                        </div>
                        <div className="col-12 md:col-6">
                            <label htmlFor="razaoSocial">Logradouro</label>
                            <InputText
                                value={cliente.logradouro}
                                onChange={handleChange}
                                name="logradouro"
                                className="w-full mt-2"
                            />
                            
                        </div>
                        <div className="col-12 md:col-1">
                            <label htmlFor="razaoSocial">Nº</label>
                            <InputText
                                value={cliente.numero}
                                onChange={handleChange}
                                name="numero"
                                className="w-full mt-2"
                            />
                            
                        </div>

                        <div className="col-12 md:col-3">
                            <label htmlFor="complemento">Complemento</label>
                            <InputText
                                value={cliente.complemento}
                                onChange={handleChange}
                                name="complemento"
                                className="w-full mt-2"
                            />
                            
                        </div>
                        <div className="col-12 md:col-3">
                            <label htmlFor="bairro">Bairro</label>
                            <InputText
                                value={cliente.bairro}
                                onChange={handleChange}
                                name="bairro"
                                className="w-full mt-2"
                            />
                            
                        </div>
                        <div className="col-12 md:col-5">
                            <label htmlFor="cidade" style={{fontWeight : 'bold'}}>Cidade *</label>
                            <InputText
                                value={cliente.cidade}
                                onChange={handleChange}
                                name="cidade"
                                className="w-full mt-2"
                            />
                            
                        </div>
                        <div className="col-12 md:col-1">
                            <label htmlFor="Estado" style={{fontWeight : 'bold'}}>Estado *</label>
                            <InputText
                                value={cliente.Estado}
                                onChange={handleChange}
                                name="Estado"
                                className="w-full mt-2"
                            />
                            
                        </div>

                         <div className="col-12 md:col-3">
                                <label htmlFor="telefoneCelular">Telefone Celular</label>
                                <InputTextTelefone
                                    value={cliente.telefoneCelular}
                                    onChange={handleChange}
                                    name="telefoneCelular"
                                    className="w-full mt-2"
                                />
                            </div>
        
                            {/* Telefone Comercial */}
                            <div className="col-12 md:col-3">
                                <label htmlFor="telefoneComercial">Telefone Comercial</label>
                                <InputTextTelefone
                                    value={cliente.telefoneComercial}
                                    onChange={handleChange}
                                    name="telefoneComercial"
                                    className="w-full mt-2"
                                />
                            </div>
        
                            {/* E-mail */}
                            <div className="col-12 md:col-6">
                                <label htmlFor="email" style={{fontWeight : 'bold'}}>E-mail*</label>
                                <>
                                <InputTextEmail
                                    value={cliente.email}
                                    onChange={handleChange}
                                    name="email"
                                    className="w-full mt-2"
                                />
                                    <small className="p-error">{errors.email}</small>
                                    </>
                            </div>

                    </div>
                     <div className="mt-4 flex justify-content-end mt-2">
                            <Button disabled={props.loading} severity="secondary" className="mt-2 mr-2" label="Cancelar" icon="pi pi-times" onClick={() => {
                                    confirmDialog({
                                    message: 'Deseja cancelar?',
                                    header: 'Confirmação',
                                    icon: 'pi pi-exclamation-triangle',
                                    acceptLabel: 'Sim',
                                    rejectLabel: 'Não',
                                    accept: () => {setVisible(false)}
                                });
                            }} />
                            <Button disabled={props.loading} severity="primary" className="mt-2 mr-2" label="Salvar" icon="pi pi-save" onClick={() => {
                                    if(!validateFields()){
                                    showMessageToast("warn", "Preencha todos os campos obrigatórios.");
                                    return
                                }
                                    confirmDialog({
                                    message: 'Confirma a inclusão desse novo Cliente?',
                                    header: 'Confirmação',
                                    icon: 'pi pi-exclamation-triangle',
                                    acceptLabel: 'Sim',
                                    rejectLabel: 'Não',
                                    accept: () => {
                                        updateCliente()
                                    } 
                                });
                            }} />
                        </div>
                </Dialog>
                <Toast ref={toast} />
            </div>
      )
    }